import * as SchemaTypes from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateBookingRequestMutationVariables = SchemaTypes.Exact<{
  skipAutomaticEmail?: SchemaTypes.InputMaybe<SchemaTypes.Scalars['Boolean']>;
  data: SchemaTypes.BookingRequestInput;
}>;

export type CreateBookingRequestMutation = {
  __typename?: 'Mutation';
  createBookingRequest: { __typename?: 'BookingRequest'; id: string };
};

export const CreateBookingRequestDocument = gql`
  mutation CreateBookingRequest($skipAutomaticEmail: Boolean, $data: BookingRequestInput!) {
    createBookingRequest(skipAutomaticEmail: $skipAutomaticEmail, data: $data) {
      id
    }
  }
`;
export type CreateBookingRequestMutationFn = Apollo.MutationFunction<
  CreateBookingRequestMutation,
  CreateBookingRequestMutationVariables
>;

/**
 * __useCreateBookingRequestMutation__
 *
 * To run a mutation, you first call `useCreateBookingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingRequestMutation, { data, loading, error }] = useCreateBookingRequestMutation({
 *   variables: {
 *      skipAutomaticEmail: // value for 'skipAutomaticEmail'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBookingRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateBookingRequestMutation, CreateBookingRequestMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateBookingRequestMutation, CreateBookingRequestMutationVariables>(
    CreateBookingRequestDocument,
    options,
  );
}
export type CreateBookingRequestMutationHookResult = ReturnType<typeof useCreateBookingRequestMutation>;
export type CreateBookingRequestMutationResult = Apollo.MutationResult<CreateBookingRequestMutation>;
export type CreateBookingRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateBookingRequestMutation,
  CreateBookingRequestMutationVariables
>;
